
<template>
  <div>
    <el-dialog
      custom-class="MyDialog"
      title="紧急联系人设置"
      :visible.sync="dialogEmergency"
      :close-on-click-modal="false"
      @close="cancelEmergency"
      width="575px"
    >
      <p>为避免您错过总部的紧急重要通知（如核心政策），系统建议您为您的组织设置最多2位紧急联系人专门用于接收此类通知并在团队内部传达。</p>
      <p>注意：被设置为“紧急联系人”的账号将在极少数（一般一个月不超过3次）的情况下接收总部电话+信息形式的通知，请提醒被设置人员注意接收电话。</p>
      <div class="select_staff">
        <span class="text_block">选择员工</span>
        <el-select 
          v-model="valueStaff" 
          multiple 
          filterable
          :multiple-limit="2"
          placeholder="请选择员工" 
          @change="selectStaff"
          style="width: 100%"
          >
          <el-option
            v-for="item in optionsStaff"
            :key="item.value"
            :label="item.label"
            :value="item.value"
            >
          </el-option>
        </el-select>
      </div>

      <el-table 
        :data="tableDataEmergency"
        border
        :header-cell-style="{
          background: 'rgb(230, 240, 252)',
          textAlign: 'center',
          color: 'black',
          borderRight: '2px solid #fff',
        }"
        :cell-style="{
          textAlign: 'center',
          padding: '0',
        }"
        style="width: 100%"
      >
          <template slot="empty">
              <el-empty  description="暂未设置" :image-size="30"></el-empty>
          </template>
          <el-table-column prop="index" label="序列"></el-table-column>
          <el-table-column prop="name" label="姓名"></el-table-column>
          <el-table-column prop="phone" label="手机号"></el-table-column>
          <el-table-column prop="ddNum" label="钉钉号"></el-table-column>
      </el-table>

      <div style="display: flex">
        <p class="text_gap">无需设置紧急联系人？点击右侧按钮取消提醒</p>
        <el-switch
          v-model="switchEmergencyValue"
          active-color="#3d76e0"
          inactive-color="#e4e7e9">
        </el-switch>
      </div>

      <span slot="footer" class="dialog-footer">
        <el-divider></el-divider>
        <el-button @click="submitEmergency" type="primary">提交</el-button>
        <el-button @click="cancelEmergency">取消</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import LoginUserHelper from "@/util/LoginUserHelper";
import { queryAccountCenterList } from "@/api/AddEmpolyee";
import { queryEmergencyContactList, updEmergencyContact } from '@/api/AccountInterface';

export default {
  data() {
    return {
      tableDataEmergency: [
        {
          index: "紧急联系人1",
          name: "未设置",
          phone: "未设置",
          ddNum: "未设置",
        },
        {
          index: "紧急联系人2",
          name: "未设置",
          phone: "未设置",
          ddNum: "未设置",
        },
      ],
      valueStaff: [],
      switchEmergencyValue: false,
      optionsStaff: [],
      dialogEmergency: false,
      campusId: LoginUserHelper.getUserInfo().campusId,
      allStaffList: []
    };
  },
  methods: {
    async init(){
      await this.queryEmergencyContactList();
      await this.queryAccountCenterList();
    },
    async queryAccountCenterList() {
      let params = {
        campusId: this.campusId
      };
      let { data, code, message } = await queryAccountCenterList(params)
      if (code === 0) {
        this.allStaffList = data;
        this.optionsStaff = data.map(item => {
          return {
            value: item.account_id,
            label: item.real_name
          };
        });
        // 默认选中状态
        // 列表中会返回两条“未设置”数据需要过滤掉
        this.valueStaff = this.tableDataEmergency.filter(item => item.accountId > 0).map(item => item.accountId);
      } else {
        this.$message.error(message)
      }
    },
    async queryEmergencyContactList() {
      try {
        const { data, code, message } = await queryEmergencyContactList({ campusId: this.campusId });
        
        if (code === 0) {
          this.tableDataEmergency = this.formatEmergencyContacts(data?.contactList || []);
          this.switchEmergencyValue = data?.isShow === 1;
        } else {
          throw new Error(message);
        }
      } catch (error) {
        this.$message.error(error.message || '获取紧急联系人列表失败');
        this.tableDataEmergency = this.getDefaultEmergencyContacts();
        this.switchEmergencyValue = false;
      }
    },

    formatEmergencyContacts(contactList) {
      if (contactList.length === 0) {
        return this.getDefaultEmergencyContacts();
      }
      return contactList.map((item, index) => ({
        index: `紧急联系人${index + 1}`,
        name: item.accountTrueName || '未设置',
        phone: item.accountPhone || '未设置',
        ddNum: item.dingPhone || '未设置',
        userId: item.userId || '',
        accountId: item.accountId || ''
      }));
    },

    getDefaultEmergencyContacts() {
      return [
        { index: '紧急联系人1', name: '未设置', phone: '未设置', ddNum: '未设置', userId: '', accountId: '' },
        { index: '紧急联系人2', name: '未设置', phone: '未设置', ddNum: '未设置', userId: '', accountId: '' }
      ];
    },
    async submitEmergency() {
      let params = {
        campusId: this.campusId,
        isShow: this.switchEmergencyValue ? 1 : 0,
        contactList: this.tableDataEmergency.map((item,index) => {
          return {
            type: index + 1,
            accountId: item.accountId,
            userId: item.userId
          };
        })
      };
      let { data, code, message } = await updEmergencyContact(params)
      if ( code === 0 && data === 1) {
          this.dialogEmergency = false;
          this.$message.success("提交成功");
        } else {
          this.$message.error("提交失败");
      }
      this.init();
    },
    cancelEmergency() {
      this.dialogEmergency = false;
      this.init();
    },
    selectStaff(value) {     
      // 创建一个Map来快速查找staff成员
      const staffMap = new Map(this.allStaffList.map(staff => [staff.account_id, staff]));
      
      // 创建两个默认的"未设置"联系人
      const defaultContact = { name: "未设置", phone: "未设置", ddNum: "未设置", userId: "", accountId: "" };
      
      // 使用map和slice来创建结果数组
      this.tableDataEmergency = value.slice(0, 2).map((accountId, index) => {
        const staffMember = staffMap.get(accountId);
        if (staffMember) {
          return {
            index: `紧急联系人${index + 1}`,
            name: staffMember.real_name,
            phone: staffMember.phone,
            ddNum: staffMember.dingPhone,
            userId: staffMember.userId,
            accountId: staffMember.account_id
          };
        }
        return { ...defaultContact, index: `紧急联系人${index + 1}` };
      });

      // 如果选择的联系人少于2个，用默认联系人填充
      while (this.tableDataEmergency.length < 2) {
        this.tableDataEmergency.push({
          ...defaultContact,
          index: `紧急联系人${this.tableDataEmergency.length + 1}`
        });
      }
    },
    removeStaff() {
      this.tableDataEmergency = this.tableDataEmergency.filter(item => {
        return this.valueStaff.includes(item.accountId);
      });
    }
  },
  components: {

  },
  mounted() {
    this.init();
  },
}
</script>

<style lang="scss" scoped>

.MyDialog {
  border-radius: 20px;

  .el-dialog__header {
    background: rgb(74, 131, 232);
    border-radius: 20px 20px 0 0;

    .el-dialog__title,
    .el-dialog__close {
      color: white;
    }
  }

  .dialog-footer {
    button {
      border-radius: 20px;
    }
  }
}

.select_staff {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin: 10px 0;
  .text_block {
    margin-right: 20px;
    display: inline-block;
    width: 100px;
  }
}

.text_gap {
  margin-right: 20px;
}


::v-deep .MyDialog .el-empty__description{
  margin-top: -10px;
  line-height: 10px;
}
::v-deep .MyDialog .el-dialog__body{
  height: 320px;
  padding: 30px 20px 10px;
}
</style>